{
  "title": "Infallible Relay (UA)",
  "source": "Unearthed Arcana 7 - Modern Magic",
  "levelAndSchool": "1st-level divination (technomagic)",
  "level": 1,
  "castingTime": "1 minute",
  "range": "Self",
  "components": "V, S, M (a mobile phone)",
  "duration": "Concentration, up to 10 minutes",
  "description": [
    "With this spell, you can target any creature with whom you have spoken previously, as long as the two of you are on the same plane of existence. When you cast the spell, the nearest functioning telephone or similar communications device within 100 feet of the target begins to ring. If there is no suitable device close enough to the target, the spell fails.",
    "The target must make a successful Charisma saving throw or be compelled to answer your call. Once the connection is established, the call is crystal clear and cannot be dropped until the conversation has ended or the spell’s duration ends. You can end the conversation at any time, but a target must succeed on a Charisma saving throw to end the conversation."
  ],
  "spellLists": ["sorcerer", "warlock", "wizard"]
}
